import { render } from "./initiator.vue?vue&type=template&id=8242e812"
import script from "./initiator.vue?vue&type=script&lang=js"
export * from "./initiator.vue?vue&type=script&lang=js"

import exportComponent from "E:\\html\\yiban-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__